
import {
  put, call, takeLatest,
} from 'redux-saga/effects';

import {
  MODALS, API_URLS, FETCH_OPTIONS, SUCCESS_MODALS,
} from '../constants';
import { requestGet, requestPost } from '../utils/request';
import { aSetIsFetching, aSetOpenModal } from '../reducers/common';
import { aGetConfigurationSettings, aGetConfigurationSettingsSuccess, aUpdateConfigSettings, aUpdateConfigSettingsSuccess } from '../reducers/configurationSettings';

/**
 * @memberof sagas/configurationSettings
 * @async
 */
function* getConfigurationSettingsSaga() {
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_CONFIGURATION_SETTINGS,
      value: true,
    }));

    const response = yield call(requestGet, API_URLS.GET_CONFIGURATION_SETTINGS, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    }
    
    response.data.sort((a, b) => a.param.localeCompare(b.param));
    yield put(aGetConfigurationSettingsSuccess({
      configurationSettings: response.data,
    }));

    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_CONFIGURATION_SETTINGS,
      value: false,
    }));
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.modal ? error.message : MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.GET_CONFIGURATION_SETTINGS,
      value: false,
    }));
  }
}

/**
 * @param {object} action
 */
function* updateConfigSettingsSaga(action) {
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.UPDATE_CONFIGURATION_SETTINGS,
      value: true,
    }));

    const requestData = { param: action.payload.data.param, value: action.payload.data.value, enabled: action.payload.data.enabled };
    const response = yield call(requestPost, API_URLS.UPDATE_MAX_ODDS_CAP_SETTINGS, requestData, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    }

    response.data.sort((a, b) => a.param.localeCompare(b.param));
    yield put(aUpdateConfigSettingsSuccess({
      configurationSettings: response.data,
    }));

    yield put(aSetOpenModal({
      modal: MODALS.SUCCESS,
      modalData: {
        message: SUCCESS_MODALS.CONFIGURATION_SETTINGS,
        additionalMessage: 'successfully',
        modal: SUCCESS_MODALS.CONFIGURATION_SETTINGS,
      },
    }));

    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.UPDATE_CONFIGURATION_SETTINGS,
      value: false,
    }));
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.modal ? error.message : MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.UPDATE_CONFIGURATION_SETTINGS,
      value: false,
    }));
  }
}

/**
 * @memberof sagas/configurationSettings
 * @async
 * @returns {void}
 */
export default function* configurationSettingsSaga() {
  yield takeLatest(aGetConfigurationSettings, getConfigurationSettingsSaga);
  yield takeLatest(aUpdateConfigSettings, updateConfigSettingsSaga);
}

